// extracted by mini-css-extract-plugin
var _1 = "use-delete-signal-confirm-modal_content__Kd1m+";
var _2 = "use-delete-signal-confirm-modal_footer__2yolz";
var _3 = "use-delete-signal-confirm-modal_footer_left__GPAh9";
var _4 = "use-delete-signal-confirm-modal_footer_right__RXzQf";
export { _1 as "content", _2 as "footer", _3 as "footer_left", _4 as "footer_right" }
